require('./brokerConvenienceMiFIDTestStep1.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');

// @components
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const BrokerConvenienceMiFIDTestIncoherenceModal = require('mifid/components/brokerConvenienceMiFIDTestIncoherenceModal/brokerConvenienceMiFIDTestIncoherenceModal');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @actions
const BrokerConvenienceMiFIDTestStep1Action = require('mifid/actions/brokerConvenienceMiFIDTest/brokerConvenienceMiFIDTestStep1.js');

// @constants
const { FIRST_STEP, SECOND_STEP } = require('constants/index');

const CLASS_NAME = 'broker-convenience-mifid-test-step-1';
const STUDY_QUESTION = 'study';
const EXPERIENCE_QUESTION = 'experience';

class BrokerConvenienceMiFIDTestStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.buildQuestionSection = this.buildQuestionSection.bind(this);
        this.buildStudyLevelSection = this.buildStudyLevelSection.bind(this);
        this.buildExperienceSection = this.buildExperienceSection.bind(this);
    }

    buildExperienceSection() {
        const { onChangeExperience } = this.props;
        return this.buildQuestionSection(EXPERIENCE_QUESTION, onChangeExperience);
    }

    buildLegendBeforeQuestions() {
        if (this.props.isConsulting) {
            return <FormattedText value="broker-convenienceMifidConsultingTestAnswerFollowingQuestions" />
        } else {
            return <FormattedText value="broker-convenienceMifidTestAnswerFollowingQuestions" />
        }
    }

    buildOmitTestButton() {
        const { immBrokerConvenienceMiFIDTest, renderStep0 } = this.props;
        let button;

        if (immBrokerConvenienceMiFIDTest.get('displayOmitTestButton') && !renderStep0) {
            button = (
                <div className={`${CLASS_NAME}__omit-button`}>
                    <OKButton
                        modifier="ghost"
                        onClick={this.props.onOmitTest}
                    >
                        <FormattedText value="broker-convenienceMifidTestConvenienceStep1OmitTest" />
                    </OKButton>
                </div>
            );
        }

        return button;
    }

    /**
     * @param {String} whichQuestion STUDY_QUESTION or EXPERIENCE_QUESTION
     * @param {Function} handleOnChange onChangeStudyLevel or onChangeExperience
     */
    buildQuestionSection(whichQuestion, handleOnChange) {
        const { immBrokerConvenienceMiFIDTest, isConsulting, renderStep0 } = this.props;
        const selectedStep = renderStep0 ? SECOND_STEP : FIRST_STEP;
        const immFirstStep = immBrokerConvenienceMiFIDTest.get('steps').get(selectedStep);
        const answer = immFirstStep.get(whichQuestion).get('answer');
        const answers = immFirstStep.get(whichQuestion).get('answers').map((immAnswer) => {
            return (
                <RadioButton
                    key={immAnswer.get('id')}
                    disabled={isConsulting}
                    label={immAnswer.get('description')}
                    value={immAnswer.get('id')}
                />
            );
        });

        let error = this.questionHasValidationError(immFirstStep, whichQuestion);

        return (
            <div className={`${CLASS_NAME}__field`}>
                <h5 className={`${CLASS_NAME}__title`}>
                    {immFirstStep.get(whichQuestion).get('question')}
                </h5>
                <RadioButtonGroup
                    name={`${whichQuestion}`}
                    idPrefix={`${whichQuestion}Prefix`}
                    onChange={handleOnChange}
                    selectedValue={answer}
                    errorState={error}
                    className={`${CLASS_NAME}__radio-group`}
                >
                    {answers}
                </RadioButtonGroup>
                {this.willShowError(error)}
            </div>
        );
    }

    buildStudyLevelSection() {
        const { onChangeStudyLevel } = this.props;
        return this.buildQuestionSection(STUDY_QUESTION, onChangeStudyLevel);
    }

    buildValidationError() {
        let error = this.stepHasValidationError();
        let errorSection;
        if (error) {
            errorSection = (
                <div className="broker-convenience-mifid-test-wizard__error-message">
                    <FormattedText value="consultMiFID-validationGenericError" />
                </div>
            );
        }
        return errorSection;
    }

    buildIncoherenceControlModalContent() {
        const { immBrokerConsultMiFID } = this.props;
        const immPreviousTest = immBrokerConsultMiFID.get('questions').toArray();

        const immPreviousEducation = immPreviousTest.find((immQuestion) => {
            return immQuestion.get('id') === '131'
        })
        const immPreviousEducationAnswers = immPreviousEducation &&
            immPreviousEducation.getIn(['respuestasArray', 'respuestasArray']);
        const immPreviousEducationAnswerSelected = immPreviousEducation &&
            immPreviousEducationAnswers.toArray().find((immAnswer) => {
                return immAnswer.get("seleccionado") === "S";
            });

        const immPreviousExperience = immPreviousTest.find((immQuestion) => {
            return immQuestion.get('id') === '136'
        })
        const immPreviousExperienceAnswers = immPreviousExperience &&
            immPreviousExperience.getIn(['respuestasArray', 'respuestasArray']);
        const immPreviousExperienceAnswerSelected = immPreviousExperience &&
            immPreviousExperienceAnswers.toArray().find((immAnswer) => {
                return immAnswer.get("seleccionado") === "S";
            });

        const studyLabel = formatText('broker-convenienceMifidTestIncoherenceModalStep1StudyLabel');
        const experienceLabel = formatText('broker-convenienceMifidTestIncoherenceModalStep1ExperienceLabel');
        return(
            <div>
                <p className={`${CLASS_NAME}__incoherence-modal-content-studies`}>
                    {studyLabel}{immPreviousEducationAnswerSelected && immPreviousEducationAnswerSelected.get('descripcion')}
                </p>
                <p className={`${CLASS_NAME}__incoherence-modal-content-experience`}>
                    <span>{experienceLabel}</span>{immPreviousExperienceAnswerSelected && immPreviousExperienceAnswerSelected.get('descripcion')}
                </p>
            </div>
        );
    }

    buildIncoherenceControlModal() {
        const {
            immBrokerConvenienceMiFIDTest,
            renderStep0,
            checkIncoherences,
            continueWithIncoherences,
            immBrokerConsultMiFID
        } = this.props;
        const selectedStep = renderStep0 ? SECOND_STEP : FIRST_STEP;
        const showModal = immBrokerConvenienceMiFIDTest.getIn(['steps', selectedStep, 'showCoherenceModal']);
        const modalContent = this.buildIncoherenceControlModalContent();
        return(
            <BrokerConvenienceMiFIDTestIncoherenceModal
                showModal={showModal}
                modalContent={modalContent}
                checkIncoherences={checkIncoherences}
                continueWithIncoherences={continueWithIncoherences}
                immBrokerConsultMiFID={immBrokerConsultMiFID}
            />
        );
    }

    buildWizardStepBody() {
        const { renderStep0 } = this.props;
        const link = formatText('disclaimerPersonalInfo-mifidGdprDisclaimerLinkUrl');
        const disclaimer = !renderStep0 ? (
            <OKMessage type="informative">
                <FormattedText value="disclaimerPersonalInfo-mifidGdprDisclaimerText" />
                &nbsp;
                <OKLink to={link} target="_blank" modifier="emphasize">
                    <FormattedText value="disclaimerPersonalInfo-mifidGdprDisclaimerLinkText" />
                </OKLink>
            </OKMessage>
        ) : null;
        return (
            <div>
                <h4 className={`${CLASS_NAME}__header-title`}>
                    <FormattedText value="broker-convenienceMifidTestFormationProfession" />
                </h4>
                <p className={`${CLASS_NAME}__info`}>
                    {this.buildLegendBeforeQuestions()}
                </p>
                {this.buildStudyLevelSection()}
                {this.buildExperienceSection()}
                {this.buildOmitTestButton()}
                {this.buildIncoherenceControlModal()}
                {disclaimer}
            </div>
        );
    }

    questionHasValidationError(immFirstStep, whichQuestion) {
        return !immFirstStep.get("valid") && immFirstStep.get("validated") && !immFirstStep.get(whichQuestion).get('valid');
    }

    stepHasValidationError() {
        const { immBrokerConvenienceMiFIDTest, renderStep0} = this.props;
        const selectedStep = renderStep0 ? SECOND_STEP : FIRST_STEP;
        const immFirstStep = immBrokerConvenienceMiFIDTest.get('steps').get(selectedStep);
        return !immFirstStep.get("valid") && immFirstStep.get("validated");
    }

    whichWizardStep() {
        const { actions, cancelButton, nextButton, isConsulting, renderStep0 } = this.props;
        const position = renderStep0 ? "middle" : "first";
        if (isConsulting) {
            const wizardStep = (
                <WizardStep
                    actions={actions}
                    goBackButton={isConsulting}
                    nextButton={nextButton}
                    position={position}
                >
                    {this.buildWizardStepBody()}
                </WizardStep>
            );
            return wizardStep;
        } else {
            const wizardStep = (
                <WizardStep
                    actions={actions}
                    cancelButton={cancelButton}
                    nextButton={nextButton}
                    position={position}
                >
                    {this.buildWizardStepBody()}
                </WizardStep>
            );
            return wizardStep;
        }
    }

    willShowError(error) {
        if (error) {
            return this.buildValidationError();
        }
    }

    render() {
        return this.whichWizardStep();
    }
}

BrokerConvenienceMiFIDTestStep1.propTypes = {
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    onChangeStudyLevel: PropTypes.func.isRequired,
    onChangeExperience: PropTypes.func.isRequired,
    cancelButton: PropTypes.bool,
    nextButton: PropTypes.bool,
    isConsulting: PropTypes.bool,
    onOmitTest: PropTypes.func.isRequired,
    renderStep0: PropTypes.bool.isRequired
};

BrokerConvenienceMiFIDTestStep1.defaultProps = {
    cancelButton: true,
    nextButton: true,
    isConsulting: false
};

module.exports.constructor = BrokerConvenienceMiFIDTestStep1;
module.exports.BrokerConvenienceMiFIDTestStep1 = connect(
    (state) => ({
        immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
        immBrokerConsultMiFID: state.brokerConsultMiFID,
    }),
    {
        onChangeStudyLevel: BrokerConvenienceMiFIDTestStep1Action.changeStudyLevel,
        onChangeExperience: BrokerConvenienceMiFIDTestStep1Action.changeExperience,
        checkIncoherences: BrokerConvenienceMiFIDTestStep1Action.checkIncoherences,
        continueWithIncoherences: BrokerConvenienceMiFIDTestStep1Action.continueWithIncoherences,
    }
)(BrokerConvenienceMiFIDTestStep1);
